import type { StudioMemberRole } from "@prisma/client";

export const ROLE_LABELS: Record<StudioMemberRole, string> = {
  OWNER: "Owner",
  ADMIN: "Admin",
  COACH: "Coach",
  GUEST_COACH: "Guest Coach",
  MEMBER: "Member",
};

export const ROLE_BADGE_STYLES: Record<StudioMemberRole, string> = {
  OWNER:
    "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
  ADMIN: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  COACH: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  GUEST_COACH:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  MEMBER: "bg-muted text-muted-foreground",
};
